export const UNFILLED_ROLES_GET_FILTERED_ROLES_BEGIN = 'UNFILLED_ROLES_GET_FILTERED_ROLES_BEGIN';
export const UNFILLED_ROLES_GET_FILTERED_ROLES_SUCCESS = 'UNFILLED_ROLES_GET_FILTERED_ROLES_SUCCESS';
export const UNFILLED_ROLES_GET_FILTERED_ROLES_FAILURE = 'UNFILLED_ROLES_GET_FILTERED_ROLES_FAILURE';
export const UNFILLED_ROLES_GET_FILTERED_ROLES_DISMISS_ERROR = 'UNFILLED_ROLES_FILTERED_GET_ROLES_DISMISS_ERROR';
